import axios from 'axios'
import { Identifier } from 'react-admin'

export function parsedTrailerInvoices(_: Identifier, formData: any) {
  let url = `/api/v1/console/accounting-trailer/extract-invoices/`
  return axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
}
